export default "__VITE_ASSET__BDRv6RJ8__"